const Builder = require('../BuilderBase');

module.exports = class LocalVerboseDateTimeColumn extends Builder {
    constructor(title, properties) {
        super('listColumn_LocalVerboseDateTime', title, properties);
    }
};
